<template>
  <div class="container">
    <p><img src="@/assets/Quest_long_logo.png"></p>
    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <div class="level">
              <div class="level-left">
                <h1 class="title">
                  Reactivate your subscription
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div>
      <p class="is-size-3">Activate your subscription here</p>
      <p class="is-size-5">Just update your credit card and your account will be activated.</p>
    </div>

    <div class="section">

      Credit Card Information

      <div class="columns">

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.firstNameOnCard.required) && $v.firstNameOnCard.$error }"
              type="text"
              placeholder="First name on card"
              value=""
              v-model.trim="$v.firstNameOnCard.$model"
            >
          </div>
        </div>

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.lastNameOnCard.required) && $v.lastNameOnCard.$error }"
              type="text"
              placeholder="Last name on card"
              v-model.trim="$v.lastNameOnCard.$model"
            >
          </div>
        </div>

      </div>

      <div class="columns">

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.ccNumber.required || !$v.ccNumber.numeric) && $v.ccNumber.$error }"
              type="text"
              placeholder="Credit card number (no spaces)"
              id="id_creditCardNumber"
              v-model.trim="$v.ccNumber.$model"
            >
          </div>
        </div>

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.cvv.required || !$v.cvv.numeric) && $v.cvv.$error }"
              type="text"
              placeholder="CVV"
              value=""
              id="id_cvv"
              v-model.trim="$v.cvv.$model"
            >
          </div>
        </div>

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.expirationMonth.required || !$v.expirationMonth.numeric || $v.expirationMonth.minLength || $v.expirationMonth.maxLength) && $v.expirationMonth.$error }"
              type="text"
              placeholder="MM (Month)"
              value=""
              id="id_creditExpirationMonth"
              v-model.trim="$v.expirationMonth.$model"
            >
          </div>
          <div
            class="help is-danger"
            v-if="!$v.expirationMonth.numeric && !$v.cvv.$error"
          >Only numbers are allowed</div>
          <div
            class="help is-danger"
            v-if="!$v.expirationMonth.minLength && !$v.cvv.$error"
          >Must be 2 numbers long</div>
          <div
            class="help is-danger"
            v-if="!$v.expirationMonth.maxLength && !$v.cvv.$error"
          >Must be 2 numbers long</div>
        </div>

        <div class="column field">
          <div class="control">
            <input
              @focus="$event.target.select()"
              class="input"
              v-bind:class="{ 'is-danger': (!$v.expirationYear.required || !$v.expirationYear.numeric || $v.expirationYear.minLength || $v.expirationMonth.maxLength) && $v.expirationYear.$error }"
              type="text"
              placeholder="YYYY (Year)"
              value=""
              id="id_creditExpirationYear"
              v-model.trim="$v.expirationYear.$model"
            >
          </div>
          <div
            class="help is-danger"
            v-if="!$v.expirationYear.numeric && !$v.cvv.$error"
          >Only numbers are allowed</div>
          <div
            class="help is-danger"
            v-if="!$v.expirationYear.minLength && !$v.cvv.$error"
          >Must be 4 numbers long</div>
          <div
            class="help is-danger"
            v-if="!$v.expirationYear.maxLength && !$v.cvv.$error"
          >Must be 4 numbers long</div>
        </div>

      </div>

    </div>

    <div class="level level-item">
      <b-checkbox v-model="agreed">I agree to the <router-link :to="{ name: 'PrivacyPolicy'}">policies</router-link> and <router-link :to="{ name: 'TermsAndConditions'}">terms</router-link>
      </b-checkbox>
    </div>

    <div class="level">
      <div class="level-item">
        <button
          :disabled="!agreed"
          class="button is-primary is-large"
          v-on:click="reactivate()"
        >Reactivate My Subscription</button>
      </div>
    </div>

    <div style="padding-bottom: 100px">
    </div>

  </div>

</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
import Divider from "bulma-divider/dist/css/bulma-divider.min.css";

export default {
  validations: {
    firstNameOnCard: {
      required
    },
    lastNameOnCard: {
      required
    },
    ccNumber: {
      required,
      numeric
    },
    cvv: {
      required,
      numeric
    },
    expirationMonth: {
      required,
      numeric,
      minLength: minLength(2),
      maxLength: maxLength(2)
    },
    expirationYear: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4)
    }
  },
  data() {
    return {
      // firstNameOnCard: "BB",
      // lastNameOnCard: "BB",
      // ccNumber: "4111111111111111",
      // cvv: "123",
      // expirationMonth: "02",
      // expirationYear: "2020",
      firstNameOnCard: "",
      lastNameOnCard: "",
      ccNumber: "",
      cvv: "",
      expirationMonth: "",
      expirationYear: "",
      agreed: false
    };
  },
  components: { Divider },
  methods: {
    async reactivate() {
      console.log(
        "reactivate()",
        this.$store.state.reactivateUserId,
        this.firstNameOnCard,
        this.lastNameOnCard,
        this.ccNumber,
        this.cvv,
        this.expirationMonth,
        this.expirationYear
      );
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showError("ERROR");
      } else {
        var userId = this.$store.state.reactivateUserId;
        var firstNameOnCard = this.firstNameOnCard;
        var lastNameOnCard = this.lastNameOnCard;
        var ccNumber = this.ccNumber;
        var cvv = this.cvv;
        var expirationMonth = this.expirationMonth;
        var expirationYear = this.expirationYear;
        await this.$store
          .dispatch("reactivateSubscription", {
            userId,
            firstNameOnCard,
            lastNameOnCard,
            ccNumber,
            cvv,
            expirationMonth,
            expirationYear
          })
          .then(
            () => {
              this.showSuccess(
                "Congratulations, your subscription is reactivated! Login with your email and password."
              );

              // Make sure we are not authenticated.
              this.$store.commit("CLEAR_SESSION");

              // Navigate to the web site for sign in.
              this.$router.push("properties");
            },
            () => {}
          );
      }
    }
  },

  mounted() {
    console.log(
      "--> !!!this.$store.state.reactivateUserId!!!",
      this.$store.state.reactivateUserId
    );
    this.$store.state.isLoginRequired = false;
  },

  beforeDestroy() {
    this.$store.state.isLoginRequired = true;
  }
};
</script>

<style>
@import "/bulma-divider/dist/css/bulma-divider.min.css";
</style>
